var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m10.02 7.977 4.043 4.043-4.043 4.043.957.957 4.043-4.043.002.002.957-.956-.002-.003.002-.002-.957-.957-.002.002-4.043-4.043z",
  className: "arrow_svg__arrow"
})));
export default SvgArrow;